import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {birthdayGiftApi} from "@/container";

/**
 * The vouchers of today's birthdays. The key is shared between the list
 * screen counter chip and the « Anniversaires du jour » screen.
 */
const useTodayBirthdays = () => {
    return useSwr(
        cacheKey('birthday-vouchers/today'),
        () => birthdayGiftApi().today()
    );
};

export default useTodayBirthdays;
